import { ServicePluginDefinition } from '@wix/sdk-types';
import {
  Context,
  GetEligibleDiscountsRequest,
  GetEligibleDiscountsResponse,
} from './service-plugins-types.js';
import {
  renameKeysFromSDKRequestToRESTRequest,
  renameKeysFromRESTResponseToSDKResponse,
} from '@wix/sdk-runtime/rename-all-nested-keys';

export interface GetEligibleDiscountsEnvelope {
  request: GetEligibleDiscountsRequest;
  metadata: Context;
}

export const provideHandlers = ServicePluginDefinition<{
  /**
   *
   * Wix calls this method when certain actions are performed on the cart or checkout.
   * For example, when an item is added to the cart or the amount of an item is updated in the checkout. */
  getEligibleDiscounts(
    payload: GetEligibleDiscountsEnvelope
  ): GetEligibleDiscountsResponse | Promise<GetEligibleDiscountsResponse>;
}>('ECOM_DISCOUNTS', [
  {
    name: 'getEligibleDiscounts',
    primaryHttpMappingPath: '/v1/eligible-discounts',
    transformations: {
      toREST: (payload: any) => {
        const toRestResponse = payload;

        return renameKeysFromSDKRequestToRESTRequest(toRestResponse);
      },
      fromREST: (payload: any) => {
        const fromRestRequest = payload;

        return renameKeysFromRESTResponseToSDKResponse(fromRestRequest);
      },
    },
  },
]);
